import configuration from '../../utilities/configuration';
import {getToModel, deleteToModel, postToModel} from "../../utilities/EffectUtility";
import {DEFAULT_API_KEY_DELETE_ENDPOINT, DEFAULT_API_KEY_CREATE_ENDPOINT, DEFAULT_API_KEYS_ENDPOINT} from "../../constants/DefaultApiEndpoints";
import ApiKeyListModel from "../../models/apikey/ApiKeyListModel";
import ApiKeyModel from "../../models/apikey/ApiKeyModel";

export async function requestApiKeysEffect() {
  return await getToModel(ApiKeyListModel, `${configuration.apiGateway}${DEFAULT_API_KEYS_ENDPOINT}`);
}

export async function deleteApiKeyEffect(keyId) {
  return await deleteToModel(String,`${configuration.apiGateway}${DEFAULT_API_KEY_DELETE_ENDPOINT.replace(':keyId', keyId)}`);
}

export async function createApiKeyEffect() {
  return await postToModel(ApiKeyModel, `${configuration.apiGateway}${DEFAULT_API_KEY_CREATE_ENDPOINT}`);
}